<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/NewExercises?Info=' + JSON.stringify(dataInfo) + '&ids=' + JSON.stringify(ids) }">返回</el-breadcrumb-item>
				<el-breadcrumb-item>新建习题册</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="mine_header p_f_a p_m_t_30">
				<div class=" header_left p_flex p_f_a p_f_c">
					<div class="p_flex p_f_a small_hand"></div>
					<el-button class="heaer_btn" type="success" @click="goBack">确定添加</el-button>
				</div>
			</div>
		</div>
		<div class="content_box p_m_t_20 overflow" :style="{ height: height + 'px' }"><view-list  :dataInfo="dataInfo" :ids='ids' @change='change'></view-list></div>
	</div>
</template>

<script>
import ViewList from './commponents/list.vue';
export default {
	name: 'NewAdd',
	components: {
		ViewList
	},
	data() {
		return {
			height: 0,
			dataInfo: {},
			ids: [],
			val:[],
			nvl:[]
		};
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/NewAdd') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	created() {
		this.dataInfo = this.$route.query
		if( this.$route.query.ids ){
			this.ids = JSON.parse(this.$route.query.ids);
			this.val = JSON.parse(this.$route.query.ids);
		}
	},
	mounted() {
		this.indexInfo();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 20;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		// 确定添加
		goBack() {
			console.log(this.nvl)
			var Ner = []
			if( this.nvl.length != 0 ){
				for( var i = 0; i<this.nvl.length; i++){
					if( this.val.indexOf(this.nvl[i] ) < 0){
						Ner.push(this.nvl[i])
					}
				}
			}
			if (this.val.length != 0) {
				    
				for( var i = 0; i<this.val.length;i++ ){
					if( this.ids.indexOf(this.val[i] )){
						this.ids.push(this.val[i])
					}
				}
				if( this.ids.length != 0 ){
					for( var i = 0 ;i<this.ids.length ;i++ ){
						if( Ner.indexOf(this.ids[i]) >= 0 ){
							delete this.ids[i]
						}
					}
				}
				
				this.$router.push({
					path: '/NewExercises',
					query: {
						Info:  JSON.stringify(this.dataInfo),
						ids: JSON.stringify(this.ids)
					}
				});
			} else {
				this.$message.error('请选择要添加的!');
			}
		},
		change(val){
			this.val = val
		}
	},

	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}
.header_left {
	height: 100%;
}
.heaer_btn {
	margin-left: auto;
	margin-right: 230px;
}
.content_box {
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/exercises/addnew.vue